import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { InitGuard } from '@core';
import { AuthExhibitorGuard } from '@core/Guards/authExhibitor.guard';
import { CountdownGuard } from '@core/Guards/countdown.guard';

const routes: Routes = [
  {
    path: '',
    canActivate:[InitGuard],
    loadChildren: () =>
      import("./LAYOUT/main/main.module").then((m) => m.MainModule),
  },
  {
    path: 'terms-conditions',
    canActivate:[InitGuard],
    loadChildren: () =>
      import("./MODULES/tnc/tnc.modules").then((m) => m.Tncmodule),
  },
  {
    path: 'privacy-policy',
    canActivate:[InitGuard],
    loadChildren: () =>
      import("./MODULES/privacy-policy/privacy-policy.module").then((m) => m.PrivacyPolicymodule),
  },
  // {
  //   path: 'teaser',
  //   loadChildren: () =>
  //     import("./MODULES/teaser/teaser.module").then((m) => m.TeaserModule),
  // },
  // {
  //   path: 'countdown',
  //   canActivate:[InitGuard],
  //   loadChildren: () =>
  //     import("./MODULES/countdown/countdown.module").then((m) => m.CountdownModule),
  // },
  // {
  //   path: 'kkb/virtual/:type',
  //   loadChildren: () => import('./MODULES/iframe/iframe.module').then( m => m.IframeModule),
  //   canActivate:[CountdownGuard]
  // },
  // {
  //   path: 'ksm/virtual/:type',
  //   loadChildren: () => import('./MODULES/iframe/iframe.module').then( m => m.IframeModule),
  //   canActivate:[CountdownGuard]
  // },
  // {
  //   path: 'livechat-mobile',
  //   loadChildren: () => import('./MODULES/livechat-mobile/livechat-mobile.module').then( m => m.LivechatMobileModule)
  // },
  // {
  //   path: 'info-product',
  //   loadChildren: () => import('./MODULES/info-product/info-product.module').then( m => m.InfoProductModule)
  // },
  // {
  //   path: 'personalize-gate/:ID',
  //   loadChildren: () => import('./MODULES/personalize-gate/personalize-gate.module').then( m => m.PersonalizeGateModule)
  // },
  // {
  //   path: 'exhibitor/:code',
  //   loadChildren: () => import('./MODULES/exhibitor-offline/exhibitor-offline.module').then( m => m.ExhibitorOfflineModule),
  //   // canActivate:[AuthExhibitorGuard]
  // },
  // {
  //   path: 'floor-plan',
  //   loadChildren: () => import('./MODULES/floor-plan/floor-plan.module').then( m => m.FloorPlanModule)
  // },
  // {
  //   path: 'solusi/:slug/:id/promo',
  //   loadChildren: () => import('./POPUP/popup-page/popup-page.module').then( m => m.PopupPageModule),
  //   canActivate:[CountdownGuard]
  // }, // Solusi page Produk detail
  // {
  //   path: 'solusi/:slug/:id/product',
  //   loadChildren: () => import('./POPUP/popup-page/popup-page.module').then( m => m.PopupPageModule),
  //   canActivate:[CountdownGuard]
  // },
  // {
  //   path: 'session/:sessionID',
  //   loadChildren: () => import('./MODULES/stream/stream.module').then( m => m.StreamModule)
  // },

  // {path:'home', loadChildren: ()=>import('./MODULES/home/home.module').then(m=>m.HomeModule)},

  {path:'**', redirectTo:'not-found'},
  {path:'not-found', loadChildren:()=>import('./MODULES/authentication/page404/page404.module').then(m=>m.Page404Module)}

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
